{
  "_vgBinding": "vg-binding: P4.4.2.D-12 P4.4.2.D-13 P4.4.2.D-14 P4.4.2.D-15 INTERFACE-STANDARDS:error-shape — complete vendorAllocations namespace (stats/configs/proposals tabs + dialogs + chip + 9 domain error codes user_message) owned by task-12; Wave-4 tabs consume t() only [task-12]",
  "page": {
    "title": "Vendor Allocations",
    "subtitle": "Per-vendor allocation stats, split weight config and change approvals.",
    "newSplit": "+ New split config"
  },
  "nav": {
    "allocations": "Allocations"
  },
  "tabs": {
    "stats": "Stats",
    "configs": "Configs",
    "proposals": "Proposals"
  },
  "common": {
    "cancel": "Cancel",
    "close": "Close",
    "save": "Save",
    "retry": "Retry",
    "loading": "Loading…",
    "confirm": "Confirm",
    "na": "N/A"
  },
  "filters": {
    "searchLabel": "Search",
    "searchPlaceholder": "SKU, blueprint, location…",
    "blueprintLabel": "Blueprint",
    "allBlueprints": "All blueprints",
    "vendorLabel": "Vendor",
    "allVendors": "All vendors",
    "statusLabel": "Status",
    "allStatuses": "All statuses",
    "dateRangeLabel": "Date range"
  },
  "stats": {
    "table": {
      "vendor": "Vendor",
      "variants": "Variants",
      "quantity": "Quantity",
      "cost": "Cost",
      "assignments": "Assignments"
    },
    "footer": {
      "totals": "Totals",
      "missingCostCaveat": "{{count}} assignments missing frozen cost"
    },
    "empty": {
      "title": "No allocation activity",
      "description": "No vendor assignments were created in this date range."
    },
    "drilldown": {
      "title": "Per-variant breakdown",
      "variant": "Variant",
      "sku": "SKU",
      "location": "Location",
      "quantity": "Quantity",
      "cost": "Cost",
      "assignments": "Assignments",
      "reconcile": "Reconciled total",
      "locationNA": "Location N/A",
      "empty": "No variant activity for this vendor in range."
    },
    "assignmentStatus": {
      "rejected": "Rejected",
      "superseded": "Superseded",
      "completed": "Completed"
    }
  },
  "configs": {
    "table": {
      "blueprint": "Blueprint",
      "variantSku": "Variant (SKU)",
      "location": "Location",
      "vendors": "Vendors",
      "actions": "Actions"
    },
    "actions": {
      "disable": "Disable",
      "propose": "Propose change",
      "openBlueprint": "Open blueprint"
    },
    "empty": {
      "title": "No split configurations",
      "description": "No blueprint variant has a vendor split yet."
    },
    "pagination": {
      "showing": "Showing {{shown}} / {{total}} configs",
      "prev": "‹ Prev",
      "next": "Next ›"
    },
    "disable": {
      "title": "Disable vendor from split",
      "lastVendorWarning": "This is the last enabled vendor — new orders will route by top-score instead of the configured split.",
      "reasonLabel": "Reason",
      "reasonRequired": "(required)",
      "reasonPlaceholder": "e.g. Vendor paused mug orders — out of blanks this week…",
      "reasonHint": "The reason is written to the allocation history for later reconciliation.",
      "confirm": "Confirm disable",
      "cancel": "Cancel",
      "toast": {
        "success": "Vendor disabled for this split."
      }
    },
    "propose": {
      "title": "Propose change",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "Explain the re-enable or weight change…",
      "weightLabel": "Weight (%)",
      "submit": "Submit proposal",
      "toast": {
        "success": "Proposal submitted for approval."
      },
      "noChanges": "No changes to propose.",
      "disableViaDirect": "To disable, use the ✕ on the vendor chip (audited). Proposals can only re-enable."
    }
  },
  "proposals": {
    "pending": {
      "title": "Pending queue"
    },
    "history": {
      "title": "History"
    },
    "table": {
      "blueprint": "Blueprint",
      "variant": "Variant",
      "location": "Location",
      "changes": "Changes",
      "reason": "Reason",
      "proposedBy": "Proposed by",
      "proposedAt": "Proposed at",
      "status": "Status",
      "decidedBy": "Decided by",
      "decidedAt": "Decided at",
      "decisionReason": "Decision reason",
      "actions": "Actions"
    },
    "status": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "change": {
      "enable": "Enable",
      "disable": "Disable",
      "weightDelta": "{{from}}% → {{to}}%",
      "weightSet": "{{to}}%"
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject"
    },
    "selfApprovalDisabled": "You cannot approve your own proposal.",
    "empty": {
      "pending": "No pending proposals.",
      "history": "No decided proposals yet."
    },
    "badge": {
      "pendingAria": "{{count}} pending proposals"
    },
    "reject": {
      "title": "Reject proposal",
      "reasonLabel": "Reason",
      "reasonRequired": "(required)",
      "reasonPlaceholder": "Explain why this proposal is rejected…",
      "confirm": "Confirm reject",
      "cancel": "Cancel",
      "toast": {
        "success": "Proposal rejected."
      }
    },
    "approve": {
      "confirmTitle": "Approve proposal",
      "toast": {
        "success": "Proposal approved and applied."
      }
    }
  },
  "chip": {
    "enabled": "Enabled",
    "disabled": "Disabled",
    "weightAria": "Weight {{pct}}%",
    "inactive": "suspended",
    "missing": "no profile"
  },
  "errors": {
    "ALLOC_SUM_INVALID": "Vendor weights must sum to 100%.",
    "ALLOC_RANGE_TOO_WIDE": "Date range must be 365 days or less.",
    "ALLOC_RANGE_INVALID": "Start date must be before end date.",
    "ALLOC_ENTRY_NOT_FOUND": "Allocation entry not found.",
    "ALLOC_ALREADY_DISABLED": "This vendor is already disabled for this split.",
    "ALLOC_PATCH_FORBIDDEN": "Editing weights on an existing split requires a proposal.",
    "PROPOSAL_SELF_APPROVAL": "You cannot approve your own proposal.",
    "PROPOSAL_STALE": "Blueprint changed since this proposal — please re-propose.",
    "PROPOSAL_PENDING_EXISTS": "A pending proposal already exists for this split.",
    "PROPOSAL_ALREADY_DECIDED": "This proposal has already been decided.",
    "PROPOSAL_DISABLE_FORBIDDEN": "To disable a vendor, use the disable action so the change is audited — it cannot be proposed.",
    "ALLOCATION_VENDOR_NOT_IN_LOCATION_BINDING": "This split sends work to a vendor the location binding does not cover. Nothing was saved — fix the allocation, or widen the binding first.",
    "locationBinding": {
      "list": "Not covered by the binding: {{list}}.",
      "more": "And {{count}} more."
    },
    "VALIDATION_FAILED": "Some fields are invalid. Please review and try again.",
    "UNAUTHENTICATED": "Please sign in to continue.",
    "FORBIDDEN": "You do not have permission to perform this action.",
    "PROPOSAL_NOT_FOUND": "Proposal not found.",
    "NETWORK_ERROR": "Network error — check your connection.",
    "GENERIC": "Something went wrong. Please try again.",
    "AUTH_CSRF_MISSING": "Your session security token is missing. Please refresh the page and try again.",
    "AUTH_CSRF_MISMATCH": "Your session security token expired. Please refresh the page and try again.",
    "TIMEOUT": "The request timed out. Please try again.",
    "INTERNAL_ERROR": "Something went wrong on our side. Please try again."
  }
}
